import * as yup from "yup";

const createListingSchema = yup.object({
  sellRent: yup.string().required("Please select sell or rent"),
  propertyName: yup.string().required("Property name is required"),
  beds: yup
    .number()
    .min(1, "At least 1 bed")
    .required("Number of beds is required"),
  baths: yup
    .number()
    .min(1, "At least 1 bath")
    .required("Number of baths is required"),
  parkingSpot: yup.string().required("Please select parking option"),
  furnished: yup.string().required("Please select furnished option"),
  address: yup.string().required("Address is required"),
  description: yup.string().required("Description is required"),
  offer: yup.string().required("Please select offer option"),
  price: yup
    .number()
    .min(1, "Price must be greater than 0")
    .required("Price is required"),
  images: yup.mixed().required("At least one image is required")
});

export default createListingSchema;
